

require('uiUtils');

var _angular = require('angular');

var _uiRouter = require('uiRouter');

var _logger = require('xo-beaver/dist/logger');

var _squid = require('squid');

var _address = require('xo-models/src/address');

var _checkout = require('xo-models/src/checkout');

var _fi = require('xo-models/src/fi');

require('xo-page-components/src/aside-header/directive');

require('xo-ui-components/src/accessibility/directive');

require('xo-ui-components/src/error-tooltip/directive');

require('xo-address-components/src/add-address/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoAddBilling', function () {
    return {
        template: _template2['default'],
        scope: {
            auth: '=?',
            token: '=?',
            doneFn: '=?',
            parentCallbacks: '=?',
            sidebar: '=?',
            showmeftsection: '=?',
            hideparenthead: '=?',
            billingaddressupdated: '=?',
            prefillAddress: '=?'
        },
        controller: ['$scope', '$element', function ($scope, $element) {
            var country = _squid.$locale.getCountryCodeISO();

            $scope.billing = true; // to denote its billing address page still
            $scope.normalize = (0, _squid.$feature)('addressNormalization');
            $scope.country = country;
            var $el = $($element);

            if ($scope.showmeftsection) {
                $scope.showmeftsection.toggle = false;
            }

            if ($scope.hideparenthead) {
                $scope.hideparenthead.toggle = true;
            }

            function isUserInputtedAddress(address) {
                return address && address.id === '0';
            }

            // Label fields has having error if needed to, and focus the first error if needed
            function handleValidation(res) {
                if (res && res.fields && res.fields.length) {
                    res.fields.forEach(function (field) {
                        if (field.field) {
                            var $field = $($el.find('[name="' + field.field + '"]'));

                            if ($field.length === 0 && field.field === 'zip') {
                                $field = $($el.find('[ng-model="address.postal_code"], [ng-model="zipCode"]'));
                            }
                            $field.addClass('backendError');
                            $field.attr('aria-invalid', true);
                        }
                    });
                }

                $el.find('form').find('.backendError, .ng-invalid').first().focus();
            }

            var prefilledAddress = $scope.prefillAddress && $scope.prefillAddress.address;

            if (prefilledAddress) {
                $scope.prefilled = true;
            }

            $scope.address = $scope.address || prefilledAddress || { country: country };

            var editFlow = function editFlow() {
                _logger.$logger.info('xo-billing_editFlow_check', {
                    'flow_type': _uiRouter.$stateParams.flow_type
                });
                if (_uiRouter.$stateParams.flow_type === 'edit') {
                    $scope.address = $scope.billingAddresses.addresses[0];
                }
            };

            (0, _squid.$populate)($scope, {
                billingAddresses: _fi.$BillingAddressesModel.instance(),
                flowEligibility: _checkout.$FlowEligibilityModel.instance($scope.token).retrieve({
                    params: {
                        geolocation: _squid.$meta.geolocation,
                        localeCountry: _squid.$locale.country
                    }
                })
            }).then(function () {
                editFlow();
                $scope.debitCardFlow = angular.isArray($scope.flowEligibility.paymentCardProductClass) && $scope.flowEligibility.paymentCardProductClass.length === 1 && $scope.flowEligibility.paymentCardProductClass[0] === 'DEBIT';

                $scope.cancelFn = function () {
                    $scope.done();
                };

                $scope.done = function (target) {
                    var el = $('.tokenization #sidepageAddCard');

                    if (el) {
                        el.removeClass('slideLeft');
                    }
                    target = target || '^.addCard';
                    _uiRouter.$state.go(target);
                };

                $scope.onSubmit = function () {
                    $scope.updateAddress();
                };

                $scope.prefill = function () {
                    $scope.address.country = $scope.country;
                    $scope.prefillAddress = new _address.$PrefillAddressModel({
                        id: $scope.token,
                        address: $scope.address
                    });

                    return $scope.prefillAddress.save({
                        data: $scope.prefillAddress,
                        success: function success(result) {
                            $scope.address = result;
                            $scope.prefilled = true;
                            $scope.showAddressFields = true;

                            (0, _angular.$timeout)(function () {
                                var value = $scope.address && $scope.address.state;
                                var $option = $el.find('[value="' + value + '"]');

                                $option.prop('selected', 'selected');
                                $option.trigger('change');
                                value = $option.attr('label');
                            }, 500);
                        }
                    });
                };

                $scope.updateAddress = function () {
                    var newBilling = new _fi.$BillingAddressModel({
                        line1: $scope.address.line1,
                        line2: $scope.address.line2,
                        city: $scope.address.city,
                        state: $scope.address.state,
                        postal_code: $scope.address.postal_code,
                        normalization_status: $scope.address.normalization_status,
                        country: country,
                        id: '0'
                    });

                    return newBilling.save({
                        data: $scope.billingAddress,
                        success: function success() {
                            if ($scope.normalize) {
                                // set to false so that html related to billing address is hidden when child is shown
                                $scope.billing = false;
                                $scope.address.full_address = newBilling.full_address;
                                _uiRouter.$state.go('.addressNormalization');
                            } else {
                                $scope.updateBillingAddressAndReturn('^.addCard', newBilling);
                            }
                        },
                        validation: function validation(res) {
                            return handleValidation(res);
                        }
                    });
                };

                $scope.uponNormalization = function (normalizedAddress, isBack) {
                    if (isBack) {
                        $scope.billing = true;
                        _uiRouter.$state.go('^');
                    } else {
                        $scope.updateBillingAddressAndReturn('^.^.addCard', normalizedAddress);
                    }
                };

                $scope.updateBillingAddressAndReturn = function (target, address) {
                    var newBillingAddress = void 0;

                    if (address && address instanceof _fi.$BillingAddressModel) {
                        newBillingAddress = address;
                    } else {
                        newBillingAddress = new _fi.$BillingAddressModel({
                            line1: address.line1,
                            line2: address.line2,
                            city: address.city,
                            state: address.state,
                            postal_code: address.postal_code,
                            normalization_status: address.normalization_status,
                            country: address.country || $scope.country,
                            full_address: address.full_address || $scope.address.full_address,
                            id: '0'
                        });
                    }

                    var addresses = $scope.billingAddresses && $scope.billingAddresses.addresses;

                    if (!isUserInputtedAddress(addresses[0])) {
                        addresses.unshift(newBillingAddress);
                    } else {
                        addresses[0] = newBillingAddress;
                    }
                    $scope.billingaddressupdated.value = true;
                    $scope.done(target);
                };

                // page transition after the page is loaded
                var el = $('.tokenization #sidepageAddCard');

                if (el) {
                    el.addClass('slideLeft');
                }
            });
        }]
    };
});

_angular.$timeout;

_uiRouter.$state;

_uiRouter.$stateParams;

_logger.$logger;

_squid.$feature;

_squid.$locale;

_squid.$meta;

_squid.$populate;

_address.$PrefillAddressModel;

_checkout.$FlowEligibilityModel;

_fi.$BillingAddressesModel;

_fi.$BillingAddressModel;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/add-card/addbilling/directive.js
// module id = ../node_modules/xo-wallet-components/src/add-card/addbilling/directive.js
// module chunks = 0